import { getOptionsFilter } from "@common/layout/components/context-search/utils/contextOptions.util";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseGetDimension {
  label?: string;
  value?: string;
}

const useGetDimension = (dimensionValue: string): [UseGetDimension] => {
  const {
    i18n: { language },
  } = useTranslation();
  const currentDimension = useMemo(() => {
    const defaultValue = { label: "", value: "" };
    const dimension = getOptionsFilter().find(option => option.value === dimensionValue);

    return dimension || defaultValue;
  }, [dimensionValue, language]);

  return [currentDimension];
};

export default useGetDimension;
